import { List, LayoutGrid } from "lucide-react";

interface Props {
  view: "list" | "board";
  onChange: (view: "list" | "board") => void;
}

/** Small icon-only List/Board segmented toggle — same visual pattern as the
 * CRM's table/board switch, reused across every jobs pipeline's board view. */
export default function ViewToggle({ view, onChange }: Props) {
  return (
    <div className="flex items-center rounded-xl border border-border overflow-hidden shrink-0">
      <button
        type="button"
        onClick={() => onChange("list")}
        title="List view"
        className={`p-2 transition-colors ${view === "list" ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground bg-surface"}`}
      >
        <List className="w-4 h-4" />
      </button>
      <button
        type="button"
        onClick={() => onChange("board")}
        title="Board view"
        className={`p-2 transition-colors ${view === "board" ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground bg-surface"}`}
      >
        <LayoutGrid className="w-4 h-4" />
      </button>
    </div>
  );
}
